import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../config/authaxios";

const initialState = { status: null, data: [], loading: false, message: '' };



export const getCategoryAction = createAsyncThunk("get-category", async (data = null, { rejectWithValue }) => {
    try {
        const response = await axios.get(`/admin/product/categories`);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data)
    }
});

const getCategorySlice = createSlice({
    name: "get-category",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(getCategoryAction.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getCategoryAction.fulfilled, (state, action) => {
            state.loading = false;
            state.message = action.payload?.message;
            state.status = action.payload.status_code;
            if(state.status==401){
                localStorage.clear()
              }
            state.data = action.payload?.response;
        });
        builder.addCase(getCategoryAction.rejected, (state, action) => {
            state.loading = false;
            state.message = action.payload?.message;
            state.status = action.payload.status_code;
            state.error = action.error.message;
        });
    },
});




export const getCategoryReducer = getCategorySlice.reducer;

